import React, { useState, useContext } from "react";
import "./CSS/LoginSignup.css";
import { ShopContext } from "../Context/ShopContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import logo from '../Components/Assets/logo.png';

const LoginSignup = () => {
    const [state, setState] = useState("Login");
    const [formData, setFormData] = useState({ username: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [agree, setAgree] = useState(false);

    const { login, register } = useContext(ShopContext);
    const navigate = useNavigate();

    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAuthAction = async (e) => {
        e.preventDefault();
        if (state === "Sign Up" && !agree) {
            toast.error("Please agree to the terms of use & privacy policy.");
            return;
        }
        setLoading(true);

        let response;
        try {
            if (state === "Login") {
                response = await login(formData);
            } else {
                response = await register(formData);
            }

            if (response && response.success) {
                toast.success(`Welcome back, ${formData.username}!`);
                navigate("/");
            } else {
                toast.error(response?.error || "An authentication error occurred.");
            }
        } catch (err) {
            toast.error("A server error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        // Main container with the gradient and animated shapes
        <div className="loginsignup">
            <div className="shape-blob one"></div>
            <div className="shape-blob two"></div>

            {/* The "Frosted Glass" Form Container */}
            <div className="loginsignup-container">
                <img src={logo} alt="Madurai Special" className="form-logo" />
                <div className="form-header">
                    <h1>{state === "Login" ? "Welcome Back" : "Create Account"}</h1>
                </div>

                <div className="loginsignup-toggle">
                    <button 
                        className={`toggle-btn ${state === "Login" ? "active" : ""}`}
                        onClick={() => setState("Login")}
                    >
                        Login
                    </button>
                    <button 
                        className={`toggle-btn ${state === "Sign Up" ? "active" : ""}`}
                        onClick={() => setState("Sign Up")}
                    >
                        Sign Up
                    </button>
                </div>

                <form onSubmit={handleAuthAction} className="loginsignup-fields">
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Username"
                            name="username" value={formData.username}
                            onChange={changeHandler} required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            placeholder="Password"
                            name="password" value={formData.password}
                            onChange={changeHandler} required
                        />
                    </div>
                    <button type="submit" className="auth-button" disabled={loading}>
                        {loading ? 'Processing...' : state}
                    </button>
                </form>

                {state === "Sign Up" && (
                    <div className="loginsignup-agree">
                        <input
                            type="checkbox" name="agree" id="agree"
                            checked={agree} onChange={() => setAgree(!agree)}
                        />
                        <p>I agree to the <Link to="/terms">Terms</Link> & <Link to="/privacy">Privacy Policy</Link>.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginSignup;